import { config } from "@/shared/config";
import { authService } from "@/features/auth/services/authService";
import type { TelegramLinkResponse } from "../types";

class TelegramService {
  async generateLink(): Promise<TelegramLinkResponse> {
    const token = await authService.getAccessToken();

    const response = await fetch(
      `${config.apiBaseUrl}${config.telegram.linkEndpoint}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const error = await response
        .json()
        .catch(() => ({ error: "Failed to generate link" }));
      throw new Error(error.error || "Failed to generate Telegram link");
    }

    return response.json();
  }
}

export const telegramService = new TelegramService();
